

export const ADD_CARD = 'ADD_CARD';
export const DELETE_CARD = 'DELETE_CARD';


export const addCard = (card) => ({
  type: ADD_CARD,
  payload: card,
});

export const deleteCard = (id) => ({
  type: DELETE_CARD,
  payload: id,
});
export const setCards = (cards) => ({
  type: 'SET_CARDS',
  payload: cards,
});
export const loadCards = (cards) => ({
  type: 'LOAD_CARDS',
  payload: cards,
});